import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import Custombutton from "../../../utils/Custombutton";
import SpaceParticles from "../../../utils/SpaceParticles";
import { Link } from "react-router-dom";

const Partner = () => {
  return (
    <div className="hero partner brands-size">
      <div class="night ">
        {/* <SpaceParticles /> */}
        <div
          className=' space h-100'
        >

        </div>
      </div>
      <div className="content px-3 py-3 px-xxl-4 py-xxl-4">
        <div
          className="news"
          style={{ background: "none", margin: "0px !important" }}
        >
          <h1>
            <div
              className="position-relative partner-heading"
              style={{ marginRight: "100px" }}
            >
              <h1
                style={{
                  position: "relative",
                  zIndex: "1",
                  textAlign: "end",
                  right: " 0px", whiteSpace: "break-spaces"
                }}
              >
                PARTNERS{" "}
              </h1>
              <h2
                className="bordered-text2"
                style={{ zIndex: "0", textAlign: "end", whiteSpace: "break-spaces" }}
              >
                PARTNERS{" "}
              </h2>
            </div>
          </h1>
          <div style={{ overflow: "hidden" }}>
            <div className="brands-cards">
              <div className="brands-1">
                <Link to={'https://hashai.co.uk/'}>
                  <img src="/assets/images/HASH AI logo mark - Dark mode.png" alt="Container" />
                </Link>
              </div>
              <div className="brands-1">
                <Link to={'https://www.srt-3.com/'}>
                  <img src="/assets/images/srt-logo-white.avif" alt="Container" />
                </Link>

              </div>{" "}
              <div className="brands-1">
                <Link to={'https://cryptify.ai/'}>
                  <img src="/assets/images/Cryptify_AI_Logo_Color_HR.png" alt="Container" />
                </Link>

              </div>
              <div className="brands-1">
                <Link to={'https://www.dioneprotocol.com/'}>
                  <img src="/assets/images/dione-logo.svg" alt="Container" />
                </Link>

              </div>{" "}
              <div className="brands-1">
                <Link to={'https://moontropica.com/'}>
                  <img src="/assets/images/moon-tropica.png" alt="Container" />
                </Link>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partner;
